import { render, staticRenderFns } from "./gnbComponent.vue?vue&type=template&id=f6e5429e&scoped=true"
import script from "./gnbComponent.vue?vue&type=script&lang=js"
export * from "./gnbComponent.vue?vue&type=script&lang=js"
import style0 from "./gnbComponent.vue?vue&type=style&index=0&id=f6e5429e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e5429e",
  null
  
)

export default component.exports